import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {
    Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import {
    BasicSelect
} from 'vue-search-select';
import PageTracker from '../../../common/PageTrackerHelper'

export default {
    name: 'Shipmentdeallocation',
    components: {
        VueElementLoading,
        Treeselect,
        BasicSelect,
        PageTracker
    },
    mixins: [PageTracker],
    data: function () {
        return {
            ShippingID: '',
            ticketId: '',
            isLoading: false,
            shipmenttypeList: [{
                text: "Delivery"
            }, {
                text: "DTO"
            }, {
                text: "RTO"
            }, {
                text: "RVP"
            }],
            shipmenttypeObj: {
                text: ""
            },
            shipmenttype: '',
            userDataKey : '',
        }
    },
    created: function () {
    },
  async mounted() {
        this.userDataKey = window.localStorage.getItem('userUniqueKey');
        let validateUser = await this.validateJwtToken();
        var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.localuserid = userdetail.userid;
        this.localusermailid = userdetail.email;

        //console.log('Mixin is working for :',result);
    },
    methods: {
        validateForm(scope) {
            this.$validator.validateAll(scope).then(result => {
                if (result) {
                    this.Update();
                }
            }).catch(() => {
                console.log('errors exist', this.errors)
            });
        },
        Update() {
            this.isLoading = true;
            this.awbArray1 = [];

            let shippingidsWithNextLine = this.ShippingID.split("\n").map(String);
            let shippingidsWithComma = this.ShippingID.split(",").map(String);
            if(shippingidsWithNextLine.length > 1) {

              $.each(shippingidsWithNextLine, (key,sid)=>{
                if(sid != null && sid !=''){
                  this.awbArray1.push(sid.trim());
                }
              })
            } else if(shippingidsWithComma.length >= 1){

              $.each(shippingidsWithComma, (key,sid)=>{
                if(sid != null && sid !=''){
                  this.awbArray1.push(sid.trim());
                }
              })
            }

            let requestobj = {
                "ShippingID": this.awbArray1,
                "shipmenttype": this.shipmenttype,
                "LastModifiedBy": this.localusermailid,
                "ticketId":this.ticketId
            }
            axios({
                method: 'POST',
                url: apiUrl.api_url + 'websupport/update/deallocate/shipment',
                data: requestobj
            })
                .then(async result => {
                    if (result.data.code == 200) {
                        let TrackerInfo = {
                            projectname:"Last Mile",
                            type: "Web",
                            userid: this.localuserid,
                            username: this.localusermailid,
                            meta: {
                                "event": "deallocateShipment",
                                "ShippingID": this.awbArray1,
                                "shipmenttype": this.shipmenttype,
                                "ticketId":this.ticketId
                            }
                        }
                        this.PageTracker(TrackerInfo);
                        this.$alertify.success(result.data.message);
                    } else {
                        this.$alertify.error(result.data.message);
                    }
                    this.isLoading = false;
                    this.reset();
                })
        },
        selectshipmenttype(obj) {
            this.shipmenttypeObj = obj,
                this.shipmenttype = obj.text;
        },
        reset() {
            this.$validator.reset();
            this.ShippingID = '';
            this.isLoading = false;
            this.shipmenttypeObj = {};
            this.shipmenttype = '';
            this.ticketId = '';
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/components/Shipmentdeallocation/Shipmentdeallocation.component.js